// @flow

export const emptyArray = [];
export const emptyObject = {};



// WEBPACK FOOTER //
// ./src/utils/constants.js